import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'

import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './config/queryClient'
// (Opcional) Visualizar queries en dev
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

// (Opcional) logger temporal de red (sólo en dev)
// import './debug/networkLogger'

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Root element not found')

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      {/* {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />} */}
    </QueryClientProvider>
  </React.StrictMode>,
)
